export default __webpack_public_path__ + "static/comfortfit-bbd1bfaef1eb0a34b1c4f9fb9cb27196.png";